<template>
  <section>
    <div v-if="draft.theDate" class="showDraftingDate">
      <span class="m-r-10">{{ draft.theDate | moment("Do MMM, YYYY") }}</span>
      <span>
        Total Drafts Sent : {{ draft.sameDateRecordsCount }}
      </span>
    </div>
    <div class="single-history-record card card-1" :class="{payAttention: payAttention}">

      <i class="fa fa-caret-right attentionArrow shakeX" v-if="payAttention" aria-hidden="true"></i>
    
       <b-row>
         <b-col cols="1">
           <b-badge :variant="draft.sendingMode.toLowerCase().includes('live') ? 'success' : 'outline-info'">{{ draft.sendingMode }}</b-badge>
         </b-col>
         <b-col cols="2">
            <h6 class="m-b-0">
              
              <a :href="`/drafts/${draft.draftPageHash}`" target="_blank">{{ draft.store.short_identifier }}{{ draft.customerInfo.orderNo }}</a>
              <b-badge v-if="hasRevision" variant="danger" size="xs" class="m-l-5" v-b-tooltip.hover title="Redesign">R</b-badge>
              </h6>
         </b-col>
         <b-col cols="1">
            <strong :class="{'text-success': draft.mailSent == 'Yes', 'text-danger': draft.mailSent == 'No'}">{{ draft.mailSent }}</strong>
         </b-col>
         <b-col cols="1">
            <strong :class="{'text-success': draft.smsSent == 'Yes', 'text-danger': draft.smsSent == 'No'}">{{ draft.smsSent }}</strong>
         </b-col>
         <b-col cols="1" >
           <b-badge @click.prevent="showFileInfo = !showFileInfo" variant="outline-warning" >
             {{ draft.DraftFiles.length }}
           </b-badge>
         </b-col>
         <b-col cols="1">
           <b-badge :variant="draft.howItsDone.toLowerCase().includes('auto') ? 'info' : 'warning'">{{ draft.howItsDone }}</b-badge>
         </b-col>
         
         <b-col cols="2">
           <span class="text-dark timingInfo">{{ draft.createdAt | moment("Do MMM YYYY") }} </span>
           <span class="text-info timingInfo">{{ draft.createdAt | moment("h:mm:ss a") }}</span>
         </b-col>
         <b-col cols="2">
           {{ draft.user ? draft.user.username : 'Auto' }}
         </b-col>
         <b-col cols="1">
            <i class="fa" :class="{'fa-envelope text-danger': draft.draftOpened == 'No', 'fa-envelope-open text-success': draft.draftOpened == 'Yes'}" aria-hidden="true"></i>
         </b-col>
       </b-row>

       <div class="fileInfo" v-if="showFileInfo">
          <a :href="draftFile.fileInfo.fileUrl" target="_blank" v-for="draftFile in draft.DraftFiles" v-bind:key="draftFile.id">{{ draftFile.fileInfo.fileUrl }}</a>
       </div> 
    </div>
  </section>
</template>

<script>
  export default {
      props: {
        draft: {
          type: Object,
          default: () => ({})
        }
      },
      data(){
        return {
           showFileInfo: false
        }
      },
      computed: {
        payAttention(){
           let needAttention = false;

           if(this.draft.mailSent == 'No' && this.draft.smsSent == 'No' && this.draft.sendingMode.toLowerCase() == "live"){
              needAttention = true;
           }
           
           return needAttention;
        },
        hasRevision(){
           let revision = false;

           for(let i=0; i < this.draft.DraftFiles.length; i++ ){
              if(this.draft.DraftFiles[i].fileInfo.fileUrl){
                 let fileUrl = this.draft.DraftFiles[i].fileInfo.fileUrl.toLowerCase()
                 const found = ['revise', 'redesign', 'revision'].some(substring=>fileUrl.includes(substring))

                 if(found){
                    revision = true;
                    break;
                 }
              }
           }

           return revision
        }
      }
  }
</script>

<style lang="scss" scoped>
  .single-history-record{
    padding: 5px;
    font-size: 13px;
    margin-bottom: 2px;
    position: relative;
    &.payAttention{
      background-color: rgb(255, 223, 223);
      border-color: rgb(255, 186, 186);

      h6{
        color: rgb(209, 12, 12);
      }
    }
  }
  .timingInfo{
    font-size: 11px;
  }
  $first-span-color: rgb(46, 56, 102);
  .showDraftingDate{
     border-bottom: 2px solid   $first-span-color;
     margin: 15px 0 5px 0;
     font-size: 13px;
     background-color: rgb(202, 233, 255);
     span:first-child{
       display: inline-block;
       padding: 5px 10px;
       color: #fff;
       background-color:   $first-span-color;
       border-radius: 5px 5px 0 0;
     }
     span:last-child{
       color: rgb(0, 82, 136);
       font-weight: 600;
     }
  }
  .attentionArrow{
     position: absolute;
     font-size: 30px;
     left: -20px;
     top: 0;
     color: red;
  }

  .fileInfo{
     margin-top: 20px;
     a{
       display: block;
       margin-bottom: 5px;
     }
  }

</style>